import { commonTransform, globalTransform } from "../handleTransformation";
import { tags } from "../constants";
import {
  DOMO_REPORT_URL,
  DOMO_REPORT_BY_ID_URL,
  MODIFY_DOMO_REPORT_URL,
  DOMO_EMBED_TOKEN_URL,
} from "services/url.service";
import { getCompanyId } from "services/identity.service";

export const domoMutations = {
  createDomoReport: {
    getUrl: () => {
      const companyId = getCompanyId();
      return DOMO_REPORT_URL(companyId);
    },
    transformResponse: (res) => globalTransform(res),
    method: "POST",
    invalidatesTags: [tags.DOMO_REPORTS],
  },
  updateDomoReport: {
    getUrl: (params) => {
      const companyId = getCompanyId();
      return MODIFY_DOMO_REPORT_URL(companyId, params?.id);
    },
    transformResponse: (res) => globalTransform(res),
    method: "PUT",
    invalidatesTags: [tags.DOMO_REPORTS],
  },
  deleteDomoReport: {
    getUrl: (params) => {
      const companyId = getCompanyId();
      return MODIFY_DOMO_REPORT_URL(companyId, params?.id);
    },
    transformResponse: (res) => globalTransform(res),
    method: "DELETE",
    invalidatesTags: [tags.DOMO_REPORTS],
  },
};

export const domoQueries = {
  getDomoReports: {
    getUrl: (params = {}) => {
      const companyId = params?.companyId ?? getCompanyId();
      const { search = '', offset = 0, limit = 15 } = params;
      return DOMO_REPORT_URL(companyId, search, offset, limit);
    },
    transformResponse: (res) => res?.entity?.rows || res?.entity || res,
    method: "GET",
    providesTags: [tags.DOMO_REPORTS],
  },
  getDomoReportById: {
    getUrl: (params) => {
      const companyId = params?.companyId ?? getCompanyId();
      return DOMO_REPORT_BY_ID_URL(companyId, params?.id);
    },
    transformResponse: (res) => {
      const entity = res?.entity;
      // Wrap single entity in array for backward compatibility with consuming code
      return Array.isArray(entity) ? entity : entity ? [entity] : [];
    },
    method: "GET",
  },
  domoEmbedToken: {
    getUrl: ({ companyName, reportId }) => {
      return DOMO_EMBED_TOKEN_URL(companyName, reportId);
    },
    transformResponse: (res) => commonTransform(res),
    method: "GET",
  },
};
